import { render } from "./DownloadPage.vue?vue&type=template&id=4d649d3e"
import script from "./DownloadPage.vue?vue&type=script&lang=js"
export * from "./DownloadPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__